import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Language } from './languages.interfaces';

@Injectable({
  providedIn: 'root',
})

/**
 * Language REST calls
 */
export class LanguagesService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get all languages
   */
  getLanguages(): Observable<Language[]> {
    const url = `${this.globals.apiRoot}/jwtlanguages`;
    return this.http.get<Language[]>(url);
  }
}
